// repairs/my-model
import { getData } from 'src/services/RestApi';
import { formatDate } from 'src/utils/date-locale';
import { paymentColor } from 'src/utils/color-rules';
import { parseStringToArrayVL } from 'src/utils/string-parsers';
import { formatDecimal } from 'src/utils/formatters';

function filterItemList(item){
  item.repairDate = formatDate(item.atTime, 'dd/MM/yyyy');
  item.services = parseStringToArrayVL(item.services);
  if (item.atKm > 0) {
    item.atKm = item.atKm.toLocaleString();
  }
  if (item.price) {
    item.price = item.price.toLocaleString();
  }
}

export const getList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/repair/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {
    result.forEach((element) => {
      filterItemList(element);
    });
  }
  return onSuccess(result);
};

export const getMyList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/repair/my-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {
    result.forEach((element) => {
      filterItemList(element);
    });
  }
  return onSuccess(result);
};

export const getMyItem = async (payload) => {
  const myId = payload.id;
  if (!myId) return {};
  
  const { result, error } = await getData('api/repair/detail', { repairId: myId });
  if(error) return {};

  // result.car = convertStringToIdName(result.car);
  // result.asset = convertStringToIdName(result.asset);
  result.services = parseStringToArrayVL(result.services);
  
  // const { car, ...json } = result;
  return result;
};

export const getBillList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/repair/bill-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {
    result.forEach((element) => {
      filterItemList(element);
      element.paymentColor = paymentColor(element.paymentStatus);
    });
  }
  return onSuccess(result);
};

export const getRepairSummary = async () => {
  const { result } = await getData('api/repair/unpaid-summary');
  return { totalPrice: formatDecimal(result) };
};